import Vue from 'vue'
import Vuex from 'vuex'
import { db, authSecond } from '@/store/firebase'
import firestoreUtil from '@/utils/firestore'

import ultraFetal from './ultra-fetal'
import formCustomization from './modules/formCustomization'
import medicalRecord from './medicalRecord'

Vue.use(Vuex)

export const store = new Vuex.Store({

  modules: {
    ultraFetal,
    formCustomization,
    medicalRecord
  },

  state: {
    user: null,
    users: [],
    company: null,
    companies: [],
    adminCompanies: [],
    studiesState: null,
    patientsState: null
  },

  getters: {
  },

  actions: {
    async saveUser ({ commit, state }, payload) {
      if (!payload.iuid) {
        const authIuid = await authSecond.createUserWithEmailAndPassword(
          payload.email,
          payload.password
        )
        payload.password = null
        payload.iuid = authIuid.user.uid
      }

      return db
        .collection('users')
        .doc(payload.iuid)
        .set(payload, { merge: true })
    },
    async saveCompany ({ commit, state }, payload) {
      payload.cnpj = payload.identity

      // Nova empresa
      if (!payload.iuid) {
        return db
          .collection('companies')
          .add(payload)
      } else {
        return db
          .collection('companies')
          .doc(payload.iuid)
          .set(payload, { merge: true })
      }
    },
    async updateDicomImages ({ commit }, info) {
      const querySnapshot = await db.collection('dicomParams').where('info.dicomStoreId', '==', info.dicomStoreId)
        .where('patId', '==', info.patId)
        .where('accessionNumber', '==', info.accessionNumber)
        .where('StudyDate', '==', info.StudyDate)
        .get()

      if (!querySnapshot.empty) {
        querySnapshot.docs.map(async (doc) => {
          await doc.ref.update({ patId: info.newPatId })
          return { id: doc.id, status: 'updated' }
        })
      }
    },
    loadUsers ({ commit, state }) {
      return db
        .collection('users')
        .where('companies', 'array-contains', state.company)
        .get()
        .then(query => {
          const users = query.docs.map(item => firestoreUtil.docToObject(item))
          commit('setUsers', users)
          return users
        })
    },
    loadCompanies ({ commit, state }) {
      return db
        .collection('companies')
        .where('identity', 'in', state.user.companies)
        .get()
        .then(query => {
          const companies = query.docs.map(item => firestoreUtil.docToObject(item))
          commit('setCompanies', companies)
          return companies
        })
    },
    loadAdminCompanies ({ commit, state }) {
      return db
        .collection('companies')
        .get()
        .then(query => {
          const companies = query.docs.map(item => firestoreUtil.docToObject(item))
          commit('setAdminCompanies', companies)
          return companies
        })
    },
    loadPrintConfig ({ commit, state }, payload) {
      return db
        .collection('printConfig')
        .doc(payload)
        .get()
        .then(doc => {
          return doc.data()
        })
    },
    loadFormCustom ({ commit, state }, payload) {
      return db
        .collection('formCustom')
        .doc(payload)
        .get()
        .then(doc => {
          return doc.data()
        })
    },
    savePrintConfig ({ commit, state }, payload) {
      return db
        .collection('printConfig')
        .doc(payload.iuid)
        .set(payload.printConfig, { merge: true })
    },
    saveFormCustom ({ commit, state }, payload) {
      return db
        .collection('formCustom')
        .doc(payload.iuid)
        .set(payload.formCustom, { merge: true })
    },
    setUser ({ commit, state, dispatch }, payload) {
      commit('setUser', payload)
      if (state.user && state.user === payload.uid && state.company && payload.companies.includes(state.company)) return
      let localCompany = JSON.parse(localStorage.getItem('company'))
      if (!localCompany || !payload.companies.includes(localCompany)) localCompany = payload.company
      commit('setCompany', localCompany)
      dispatch('loadCompanies')
    },
    setStudiesState ({ commit, state }, payload) {
      commit('setStudiesState', payload)
    },
    setPatientsState ({ commit, state }, payload) {
      commit('setPatientsState', payload)
    },
    setCompany ({ commit, state }, payload) {
      commit('setCompany', payload)
    }
  },

  mutations: {
    setUsers (state, payload) {
      state.users = payload
    },
    setUser (state, payload) {
      state.user = payload
    },
    setCompany (state, payload) {
      state.company = payload
      localStorage.setItem(`company`, JSON.stringify(payload))
    },
    setCompanies (state, payload) {
      state.companies = payload
    },
    setAdminCompanies (state, payload) {
      state.adminCompanies = payload
    },
    setStudiesState (state, payload) {
      state.studiesState = payload
    },
    setPatientsState (state, payload) {
      state.patientsState = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js